import { Router } from '@vaadin/router';
import eruda from 'eruda';
import './styles/index.scss';
import './register-sw';
import { getTheme, setTheme } from './theming';
import { requireAuth } from './auth/guard';
import { LitPage } from './components/lit-page';

setTheme(getTheme());

import './pages/app-shell.ts';
import './pages/app-home.ts';
import './pages/app-picker.ts';
import './pages/app-config.ts';
import './pages/app-appearance.ts';
import './pages/app-programme.ts';
import './pages/app-puzzle.ts';
import './pages/app-auth-callback.ts';
import './pages/app-login.ts';
import './pages/app-reset-password.ts';
import './pages/app-forgot-password.ts';
import './pages/app-magic-link.ts';
import './pages/app-programmes.ts';
import './pages/app-programme-builder.ts';

const appDiv = document.getElementById('app');
// Dev HMR / service-worker updates can re-execute this module in a live tab.
// Bootstrap exactly once: a second shell would render the whole screen twice,
// and a second Router on the same outlet would render every routed page twice.
if (!appDiv?.querySelector('app-shell')) {
  const shell = document.createElement('app-shell') as LitPage;
  appDiv.appendChild(shell);
  await shell.updateComplete;

  const outlet = shell.querySelector<HTMLElement>('.app-shell__outlet');
  const router = new Router(outlet);

  router.setRoutes([
    { path: '/', component: 'app-home' },
    { path: '/programme', component: 'app-programme', action: requireAuth },
    { path: '/appearance', component: 'app-appearance', action: requireAuth },
    { path: '/puzzles/:puzzleName/boards', component: 'app-picker', action: requireAuth },
    { path: '/puzzles/:puzzleName/custom', component: 'app-config', action: requireAuth },
    { path: '/puzzles/:puzzleName', component: 'app-puzzle', action: requireAuth },
    { path: '/puzzles/:puzzleName/:level', component: 'app-puzzle', action: requireAuth },
    { path: '/auth/callback', component: 'app-auth-callback' },
    { path: '/auth/reset-password', component: 'app-reset-password' },
    { path: '/auth/forgot-password', component: 'app-forgot-password' },
    { path: '/auth/magic-link', component: 'app-magic-link' },
    { path: '/login', component: 'app-login' },
    { path: '/programmes', component: 'app-programmes', action: requireAuth },
    { path: '/programmes/:participantEmail', component: 'app-programme-builder', action: requireAuth },
  ]).catch(console.error);
}

if (isMobileOrTablet()) {
  eruda.init();
}

function isMobileOrTablet(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
  return /Mobi|Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

export { navigate } from './navigation';
